/**
 * @copyright 2023 Nuance Communications Inc.
 * All Rights Reserved.
 */

export const emailFormat = /^.+@.+\..+$/;
